/* RESPONSIBLE TEAM: team-inbox-management */
import { helper } from '@ember/component/helper';
import {
  normalizePriority,
  priorityLevelDisplay,
  type PriorityLevelDisplay,
} from 'embercom/lib/inbox/priority-levels';

// Template helper that maps a priority value (number, or legacy boolean from
// pre-multi-level call sites) to its display metadata (icon + name). Templates
// use the result to pick the right `ic-interface-icon` glyph without
// hard-coding per-level branches in markup. Boolean/null/undefined are
// coerced via `normalizePriority` so the helper and Conversation deserializers
// stay in lockstep on edge cases.
function priorityLevelDisplayHelper([value]: [
  number | boolean | undefined | null,
]): PriorityLevelDisplay {
  return priorityLevelDisplay(normalizePriority(value));
}

const PriorityLevelDisplayHelper = helper(priorityLevelDisplayHelper);
export default PriorityLevelDisplayHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'priority-level-display': typeof PriorityLevelDisplayHelper;
  }
}
